'use strict';

(function () {
  'use strict';

  /**
   * This directive adds a delay before showing the element.
   * Used to cover WCAG issue in Safari/Firefox browsers for
   * angular material select(dropdown) - after picking an option 
   * it sets focus to chosen option with delay,
   * that interrupts announcing of the status/alert text.
   */

  angular.module('msCore').directive('msDelayIf', msDelayIf);

  msDelayIf.$inject = ['$timeout', '$compile'];

  function msDelayIf($timeout, $compile) {
    var directive = {
      link: link,
      restrict: 'A'
    };

    function link(scope, elem, attr) {
      var delay = attr.delay;
      var key = 'msDelayIf' + Math.random().toString(36).substring(2);
      scope[key] = false;
      elem.attr('ng-if', key);
      elem.removeAttr('ms-delay-if');
      $compile(elem)(scope);
      var timeout;

      scope.$watch(attr.msDelayIf, function (newValue) {
        $timeout.cancel(timeout);
        if (newValue) {
          timeout = $timeout(function () {
            scope[key] = newValue;
          }, delay);
        } else {
          scope[key] = false;
        }
      });
    }

    return directive;
  }
})();